import { fetchWithAppCheck } from "./fetchWithAppCheck"

export const getDictionaries = async () => {
 
  
    try {
      const result = await fetchWithAppCheck(
        `${import.meta.env.VITE_APP_API}/dictionary`,
        {
          method: "GET",
        }
      )
      const resultJSON = await result.json()
      console.log("resultJSON", resultJSON)
      return resultJSON

    } catch (error) {
      return {
        error: {
          code: "error",
          message: "Something went wrong. Please try again later.",
          error: error
        }
      }
    }
  }